/**
 * alien-presets-identity.js
 * Danh mục định danh (name, title, defaultReactions) cho 30 Alien Presets.
 * Thuần dữ liệu, bảo toàn trọn vẹn bản sắc từ commit 390ba71.
 */

export const ALIEN_PRESET_IDENTITIES = {
  ALIEN_IGNIS_HORN: {
    name: 'Người Lửa Nham Thạch (Ignis Prime)',
    title: 'Ignis Prime • Sừng năng lượng địa nhiệt',
    defaultReactions: [
      { action: 'wave', text: 'Chào mừng bạn tới Ignis Prime! Nơi năng lượng địa nhiệt sưởi ấm mọi tâm hồn lữ khách.' },
      {
        action: 'present',
        text: 'Cặp sừng năng lượng giúp chúng tôi hấp thu nhiệt lượng dư thừa và bảo tồn sinh thái tinh cầu.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi khai thác magma tuần hoàn khép kín, giữ cho bầu khí quyển luôn trong lành.'
      }
    ]
  },
  ALIEN_SERAPH_WING: {
    name: 'Thiên Sứ Ánh Sáng (Aethelgard)',
    title: 'Aethelgard • Đôi cánh quang học photon',
    defaultReactions: [
      { action: 'wave', text: 'Nguyện ánh sáng tri thức của Aethelgard soi rọi tâm hồn mọi lữ khách không gian!' },
      {
        action: 'cheer',
        text: 'Đôi cánh photon cho phép loài Aethel lướt êm ả trên các dòng gió mặt trời thanh bình.'
      },
      {
        action: 'present',
        text: 'Trang phục phát quang này tích tụ năng lượng từ ba ngôi sao rực rỡ nhất hệ thiên hà.'
      }
    ]
  },
  ALIEN_CYCLOPS_EYE: {
    name: 'Người Độc Nhãn Tinh Cầu (Cyclopia IV)',
    title: 'Cyclopia IV • 1 Mắt thấu thị đa phổ',
    defaultReactions: [
      {
        action: 'think',
        text: 'Mắt độc nhãn của tôi nhìn thấu 16 dải quang phổ, giúp khám phá các định luật vật lý mới.'
      },
      {
        action: 'explain',
        text: 'Tại Cyclopia IV, một con mắt tập trung toàn bộ năng lượng thần kinh cho sự thấu cảm và sáng tạo.'
      },
      { action: 'present', text: 'Chúng tôi chia sẻ những bản đồ thiên văn đa chiều cho mọi nền văn minh thân hữu.' }
    ]
  },
  ALIEN_CYBORG_MECHA: {
    name: 'Cư Dân Bionic Cơ Giới (Neon-Synthetica)',
    title: 'Neon-Synthetica • Vi mạch sinh học nano',
    defaultReactions: [
      {
        action: 'explain',
        text: 'Khởi động hệ điều hành CyberOS... Quét đối tượng hoàn tất. Chúc bạn một ngày an lành!'
      },
      {
        action: 'present',
        text: 'Cơ thể chúng tôi kết hợp hợp kim nano và lò vi phản ứng hạt nhân sạch để phục vụ thám hiểm.'
      },
      {
        action: 'cheer',
        text: 'Hệ thống vi mạch tự phục hồi giúp chúng tôi làm việc bền bỉ trong môi trường vũ trụ khắc nghiệt.'
      }
    ]
  },
  ALIEN_CRYO_FROST: {
    name: 'Người Băng Tinh Tuyết Tộc (Cryonia)',
    title: 'Cryonia • Sừng băng siêu dẫn',
    defaultReactions: [
      {
        action: 'wave',
        text: 'Chào mừng bạn đến với cõi băng thanh bình Cryonia, nơi tuyết trắng vĩnh cửu bao bọc tâm hồn.'
      },
      {
        action: 'present',
        text: 'Sừng tinh thể băng trên đầu là cảm biến nhiệt cực nhạy, giúp chúng tôi nhận biết sự thay đổi vi khí hậu.'
      },
      { action: 'explain', text: 'Chúng tôi sử dụng năng lượng tinh thể băng siêu dẫn để thắp sáng các đô thị ngầm.' }
    ]
  },
  ALIEN_AQUALUX: {
    name: 'Người Thủy Tộc Biển Sâu (Aquaterra)',
    title: 'Aquaterra • Vây lưng đại dương ngầm',
    defaultReactions: [
      { action: 'wave', text: 'Aquaterra là hành tinh với đại dương ngầm xanh biếc sâu hàng vạn dặm.' },
      { action: 'present', text: 'Vây lưng khí động học giúp tôi bơi lội êm ả cùng các loài sinh vật biển hiền hòa.' },
      { action: 'cheer', text: 'Các rạn san hô phát quang ở đây tạo nên khung cảnh lộng lẫy dưới đáy biển sâu!' }
    ]
  },
  ALIEN_SYLVA_FLORA: {
    name: 'Mộc Nhân Sinh Học (Sylva Prime)',
    title: 'Sylva Prime • Gai thực vật & hoa diệp lục',
    defaultReactions: [
      {
        action: 'wave',
        text: 'Hãy hít thở không khí thuần khiết nhất vũ trụ từ những đại thụ khổng lồ của Sylva Prime!'
      },
      {
        action: 'explain',
        text: 'Cơ thể chúng tôi quang hợp trực tiếp từ ánh sáng ngôi sao nhị phân để bảo vệ tài nguyên.'
      },
      { action: 'present', text: 'Chúng tôi ươm mầm cây xanh phủ khắp các vùng đất cằn cỗi trên toàn ngân hà.' }
    ]
  },
  ALIEN_VOID_SHADE: {
    name: 'Sứ Giả Hư Không (Umbra-9)',
    title: 'Umbra-9 • Hư không sâu thẳm',
    defaultReactions: [
      {
        action: 'think',
        text: 'Nơi Umbra-9, bóng đêm là chiếc nôi tĩnh lặng nuôi dưỡng tư duy triết học sâu sắc...'
      },
      {
        action: 'present',
        text: 'Chúng tôi thấu hiểu vật chất tối và kết nối không gian đa chiều vì hòa bình vũ trụ.'
      },
      {
        action: 'explain',
        text: 'Bóng tối và ánh sáng là hai nửa cân bằng của vũ trụ, hãy đón nhận cả hai với lòng rộng mở.'
      }
    ]
  },
  ALIEN_GEM_CRYSTAL: {
    name: 'Thạch Anh Đa Sắc (Krystalia)',
    title: 'Krystalia • Tinh thể lăng kính tán sắc',
    defaultReactions: [
      {
        action: 'wave',
        text: 'Krystalia là viên ngọc lộng lẫy lơ lửng trong không gian! Mọi tia sáng đều bị tán sắc rực rỡ.'
      },
      {
        action: 'present',
        text: 'Các khối tinh thể trên cơ thể hoạt động như pin lưu trữ năng lượng quang học tự nhiên.'
      },
      { action: 'cheer', text: 'Năng lượng quang học này được dùng để thắp sáng các công trình nghệ thuật tinh xảo.' }
    ]
  },
  ALIEN_VENOM_TOXIS: {
    name: 'Cư Dân Thích Ứng Khí Quyển (Venom-Ooze)',
    title: 'Venom-Ooze • Khí quyển đặc thù',
    defaultReactions: [
      {
        action: 'explain',
        text: 'Hệ sinh thái Venom-Ooze giúp chúng tôi nghiên cứu các chu trình hóa học tái chế hoàn toàn chất thải.'
      },
      { action: 'present', text: 'Bình nén sau lưng cung cấp hỗn hợp khí sinh học cần thiết cho sự sống của tôi.' },
      { action: 'wave', text: 'Mặt nạ chuyên dụng này bảo đảm an toàn sinh học tuyệt đối khi giao lưu cùng các bạn!' }
    ]
  },
  ALIEN_GRAVITON: {
    name: 'Cự Nhân Trọng Lực (Baro-Prime)',
    title: 'Baro-Prime • Siêu trọng lực 50G',
    defaultReactions: [
      {
        action: 'cheer',
        text: 'Tại Baro-Prime với trọng lực 50G, cơ thể chúng tôi được rèn luyện sức bền phi thường!'
      },
      {
        action: 'present',
        text: 'Khung xương hợp kim sinh học giúp chúng tôi hỗ trợ xây dựng các trạm không gian kiên cố.'
      },
      { action: 'hands_behind_back', text: 'Chúng tôi dùng sức mạnh để kiến tạo và bảo vệ hòa bình liên sao.' }
    ]
  },
  ALIEN_ZEPHYR_STRIDER: {
    name: 'Phong Linh Tinh Thần (Aetheria)',
    title: 'Aetheria • Trọng lực 0.1G lơ lửng',
    defaultReactions: [
      {
        action: 'wave',
        text: 'Aetheria gần như không có trọng lực, chúng tôi cả đời sống lơ lửng giữa những đám mây ngũ sắc.'
      },
      { action: 'cheer', text: 'Đôi cánh lướt gió khí động học cho phép tôi bay lượn nhẹ nhàng cùng mây trời.' },
      {
        action: 'explain',
        text: 'Chỉ cần một làn gió thoảng, chúng tôi có thể chu du khắp tinh cầu trong một buổi sáng thanh bình.'
      }
    ]
  },
  ALIEN_FULGOR_SPARK: {
    name: 'Cư Dân Điện Từ (Voltaria)',
    title: 'Voltaria • Năng lượng điện từ sấm sét',
    defaultReactions: [
      { action: 'cheer', text: 'Bão sét Voltaria chính là nguồn năng lượng tái tạo sạch vô tận của chúng tôi!' },
      { action: 'present', text: 'Cuộn dây Tesla sau lưng điều hòa từ trường để sưởi ấm cộng đồng dân cư.' },
      { action: 'explain', text: 'Sừng ăng-ten của tôi có thể truyền phát thông điệp hòa bình qua các tầng điện ly.' }
    ]
  },
  ALIEN_MERCURY_METAL: {
    name: 'Cư Dân Kim Loại Lỏng (Hydrargis)',
    title: 'Hydrargis • Thân thể chrome phản chiếu',
    defaultReactions: [
      {
        action: 'present',
        text: 'Các phân tử kim loại lỏng thông minh giúp cơ thể chúng tôi tự điều chỉnh phù hợp với mọi môi trường.'
      },
      { action: 'explain', text: 'Bề mặt chrome này phản chiếu 99.9% nhiệt lượng, bảo vệ cơ thể khỏi bức xạ gay gắt.' },
      {
        action: 'cheer',
        text: 'Chúng tôi chia sẻ công nghệ vật liệu thông minh cho các dự án thám hiểm liên hành tinh.'
      }
    ]
  },
  ALIEN_FUNGAL_SPORE: {
    name: 'Người Bào Tử Dạ Quang (Fungalia)',
    title: 'Fungalia • Mũ nấm phát quang sinh học',
    defaultReactions: [
      {
        action: 'wave',
        text: 'Chào lữ khách! Fungalia rực rỡ trong đêm tối nhờ mạng lưới bào tử dạ quang kết nối toàn cầu!'
      },
      {
        action: 'explain',
        text: 'Mũ nấm là trung tâm cảm nhận vi sinh giúp chúng tôi giao tiếp bằng tần số sóng ánh sáng.'
      },
      { action: 'cheer', text: 'Bào tử của chúng tôi có thể thanh lọc độc tố không gian và nuôi dưỡng thảm thực vật.' }
    ]
  },
  ALIEN_ASTRAL_ENERGY: {
    name: 'Cư Dân Năng Lượng Tinh Tú (Stardust-Nova)',
    title: 'Stardust-Nova • Năng lượng sao xung thuần khiết',
    defaultReactions: [
      { action: 'wave', text: 'Cơ thể chúng tôi là dòng plasma lượng tử được ổn định bằng từ trường hòa bình.' },
      {
        action: 'present',
        text: 'Vành đai năng lượng xoay quanh eo giúp tôi điều hòa và sẻ chia năng lượng cho các trạm nghiên cứu.'
      },
      { action: 'cheer', text: 'Chúng tôi sống hòa thuận cùng chu kỳ của các ngôi sao xung hàng tỷ năm.' }
    ]
  },
  ALIEN_DUNE_NOMAD: {
    name: 'Du Mục Sa Mạc (Dune-Solaris)',
    title: 'Dune-Solaris • Du mục sa mạc cát vàng',
    defaultReactions: [
      { action: 'wave', text: 'Biển cát Dune-Solaris bao la dạy chúng tôi biết trân trọng từng giọt nước quý giá.' },
      {
        action: 'explain',
        text: 'Trang phục du mục tuần hoàn 99.8% độ ẩm, minh chứng cho sự tôn trọng tuyệt đối tài nguyên thiên nhiên.'
      },
      { action: 'present', text: 'Kính ngắm quang học giúp tôi tìm ra những ốc đảo ngầm mát lành giữa sa mạc.' }
    ]
  },
  ALIEN_RUNE_GOLEM: {
    name: 'Học Giả Cổ Tự Đá Phiến (Archaea-Rune)',
    title: 'Archaea-Rune • Đá phiến khắc cổ tự rune',
    defaultReactions: [
      {
        action: 'explain',
        text: 'Những ký tự rune phát sáng trên da lưu giữ kiến thức quý giá của các tiền nhân vũ trụ.'
      },
      { action: 'present', text: 'Mỗi cổ tự rune chứa đựng công thức vận hành hài hòa với các quy luật tự nhiên.' },
      { action: 'think', text: 'Hãy cùng ngồi xuống và lắng nghe bài học kiên nhẫn từ những phiến đá ngàn năm.' }
    ]
  },
  ALIEN_RAD_MUTANT: {
    name: 'Kỹ Sư Năng Lượng Bức Xạ (Radia-66)',
    title: 'Radia-66 • Năng lượng đồng vị bức xạ sạch',
    defaultReactions: [
      {
        action: 'cheer',
        text: 'Bức xạ đồng vị tại Radia-66 đã được chúng tôi thuần hóa thành năng lượng phát triển xanh.'
      },
      {
        action: 'explain',
        text: 'Lò phản ứng mini trên ngực cung cấp năng lượng an toàn cho toàn bộ thiết bị sinh hoạt.'
      },
      {
        action: 'present',
        text: 'Chúng tôi đang hỗ trợ các hành tinh bạn xử lý và tái chế chất thải phóng xạ thành công.'
      }
    ]
  },
  ALIEN_CHRONO_KEEPER: {
    name: 'Vệ Binh Thời Gian (Chronopolis)',
    title: 'Chronopolis • Đồng hồ nghịch đảo thời gian',
    defaultReactions: [
      {
        action: 'think',
        text: 'Tại Chronopolis, thời gian là dòng sông êm đềm nối liền quá khứ, hiện tại và tương lai.'
      },
      {
        action: 'present',
        text: 'Bánh răng cơ khí sau lưng tôi giữ cho nhịp sinh học luôn ổn định trong các chuyến du hành thời gian.'
      },
      {
        action: 'wave',
        text: 'Thật vui được gặp lại bạn! Tình bạn của chúng ta đã được dự báo từ trước trong dòng thời gian.'
      }
    ]
  },
  ALIEN_MIDAS_GOLD: {
    name: 'Cư Dân Hoàng Kim (Aurum-Vega)',
    title: 'Aurum-Vega • Sừng ngọc hoàng kim',
    defaultReactions: [
      {
        action: 'cheer',
        text: 'Aurum-Vega là tinh cầu phồn thịnh, nơi vàng và ngọc bích được dùng để chế tạo pin mặt trời hiệu suất cao.'
      },
      {
        action: 'present',
        text: 'Đôi sừng ngọc lục bảo là biểu tượng văn hóa tôn vinh sự kết hợp hài hòa giữa khoáng vật và sự sống.'
      },
      { action: 'wave', text: 'Hãy đón nhận viên ngọc tinh tú này như món quà lưu niệm thắt chặt tình hữu nghị!' }
    ]
  },
  ALIEN_EVENT_HORIZON: {
    name: 'Nhà Nghiên Cứu Lỗ Đen (Singularis)',
    title: 'Singularis • Đĩa bồi tụ chân trời sự kiện',
    defaultReactions: [
      {
        action: 'explain',
        text: 'Chân trời sự kiện tại Singularis mở ra cánh cửa nghiên cứu vật lý hấp dẫn hiện đại nhất.'
      },
      {
        action: 'present',
        text: 'Đĩa bồi tụ bao quanh thân thể giúp hấp thụ bụi sao để bảo vệ trạm quan sát không gian.'
      },
      { action: 'think', text: 'Khám phá bí ẩn của lỗ đen là chìa khóa mở rộng nhận thức của mọi nền văn minh.' }
    ]
  },
  ALIEN_SYNAPSE_MIND: {
    name: 'Cư Dân Tâm Trí Đồng Thuận (Synapse-Net)',
    title: 'Synapse-Net • Mạng lưới thấu cảm vi lượng',
    defaultReactions: [
      {
        action: 'think',
        text: 'Chúng tôi giao tiếp trực tiếp qua sóng thần kinh vi lượng với lòng chân thành tuyệt đối.'
      },
      {
        action: 'explain',
        text: 'Mạng tri thức chung của Synapse-Net được chia sẻ miễn phí cho mọi sinh mệnh tìm kiếm hiểu biết.'
      },
      { action: 'present', text: 'Cảm biến lượng tử này dịch ngôn ngữ sinh học của bạn thành những hình ảnh ấm áp.' }
    ]
  },
  ALIEN_STEAMPUNK_PILOT: {
    name: 'Kỹ Sư Cơ Khí Nhiệt Năng (Steam-Cog)',
    title: 'Steam-Cog • Nồi hơi cơ khí & bánh răng đồng',
    defaultReactions: [
      {
        action: 'cheer',
        text: 'Áp suất nồi hơi đạt chuẩn! Hơi nước khoáng nóng Steam-Cog là năng lượng sạch tuần hoàn tuyệt hảo!'
      },
      {
        action: 'present',
        text: 'Bộ bánh răng đồng thau sau lưng hoạt động 100% bằng cơ học chính xác, không gây ô nhiễm.'
      },
      { action: 'wave', text: 'Tàu thám hiểm của bạn có cần bảo dưỡng động cơ không? Tôi luôn sẵn sàng giúp đỡ!' }
    ]
  },
  ALIEN_AURORA_FAERIE: {
    name: 'Người Du Mục Cực Quang (Borealis-V)',
    title: 'Borealis-V • Dải lụa cực quang dạ quang',
    defaultReactions: [
      {
        action: 'cheer',
        text: 'Bầu trời Borealis-V đổi màu từng phút theo các luồng gió mặt trời xanh lam, hồng ngọc và lục bảo!'
      },
      {
        action: 'wave',
        text: 'Dải lụa cực quang dạ quang sau lưng tôi sưởi ấm cho mọi sinh vật lạc bước trong đêm lạnh.'
      },
      { action: 'present', text: 'Chúng tôi dệt ánh sáng sao thành những giai điệu êm dịu nhất thiên hà.' }
    ]
  },
  ALIEN_COSMIC_NEBULA: {
    name: 'Nhà Quan Sát Tinh Vân (Nebula-Prime)',
    title: 'Nebula-Prime • Da đốm sao thiên hà',
    defaultReactions: [
      {
        action: 'explain',
        text: 'Mỗi đốm sáng trên cơ thể tương ứng với một ngôi sao đang hình thành trong tinh vân Stardust.'
      },
      { action: 'think', text: 'Tất cả chúng ta đều sinh ra từ bụi của những vì sao cổ xưa thuở vũ trụ khai nguyên.' },
      { action: 'cheer', text: 'Hãy nhìn vào vẻ đẹp của dải ngân hà và cùng nhau giữ gìn sự yên bình cho vũ trụ.' }
    ]
  },
  ALIEN_BONE_CARVER: {
    name: 'Người Cốt Giáp Cổ Xưa (Ossuary-Prime)',
    title: 'Ossuary-Prime • Bảo tàng cổ sinh vật học',
    defaultReactions: [
      {
        action: 'present',
        text: 'Ossuary-Prime là nơi lưu giữ mẫu hóa thạch của các loài sinh vật cổ xưa dài hàng trăm dặm.'
      },
      {
        action: 'cheer',
        text: 'Trang phục cốt giáp này được tạo ra từ khoáng vật canxi kết tinh, kiên cố và trang nghiêm.'
      },
      {
        action: 'hands_behind_back',
        text: 'Chúng tôi gìn giữ di sản quá khứ để răn dạy thế hệ mai sau về quy luật sinh tồn bền vững.'
      }
    ]
  },
  ALIEN_QUANTUM_ASTRONAUT: {
    name: 'Nhà Khám Phá Lượng Tử (Quantum-X)',
    title: 'Quantum-X • Bộ giáp lượng tử thám hiểm',
    defaultReactions: [
      {
        action: 'wave',
        text: 'Chào đồng nghiệp! Tôi là đại diện đoàn thám hiểm lượng tử Quantum-X sẵn sàng hỗ trợ bạn.'
      },
      {
        action: 'explain',
        text: 'Bộ giáp thám hiểm này trang bị động cơ sạch và hệ thống sinh quyển khép kín vĩnh cửu.'
      },
      {
        action: 'present',
        text: 'Cảm biến lượng tử đang vẽ bản đồ các tuyến hành lang an toàn nhất để chúng ta cùng du hành.'
      }
    ]
  },
  ALIEN_INSECT_HUMAN: {
    name: 'Người Giáp Kitin Sinh Học (Entomo-Hive)',
    title: 'Entomo-Hive • Cánh bọ kitin ngọc bích',
    defaultReactions: [
      {
        action: 'cheer',
        text: 'Lớp vỏ kitin tự nhiên của loài Chitinite có thể chịu được áp suất cao và điều hòa thân nhiệt.'
      },
      { action: 'present', text: 'Đôi cánh sinh học giúp tôi bay lượn linh hoạt giữa các tán rừng rậm tinh cầu.' },
      {
        action: 'explain',
        text: 'Chúng tôi là những chuyên gia bảo vệ và nhân giống các loài côn trùng thụ phấn cho thiên hà.'
      }
    ]
  },
  ALIEN_DRAGON_BLOOD: {
    name: 'Long Nhân Hậu Duệ (Drakonis)',
    title: 'Drakonis • Sừng, cánh & vảy rồng hoàng gia',
    defaultReactions: [
      {
        action: 'cheer',
        text: 'Khí phách long tộc vũ trụ luôn hướng về công lý và tình hữu nghị bền chặt giữa muôn loài!'
      },
      {
        action: 'present',
        text: 'Đôi sừng và cánh rồng là minh chứng cho sự kiên cường và lòng quả cảm vượt qua mọi thử thách.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi dùng ngọn lửa long hỏa để sưởi ấm hành tinh và kiến tạo các công trình kiến trúc kỳ vĩ.'
      }
    ]
  }
};
